define(["exports"], function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var question_pass_percentage = exports.question_pass_percentage = 35;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/utils/appConstants.js
// module id = 1196
// module chunks = 0